// extracted by mini-css-extract-plugin
export var children = "X_bh";
export var parent = "X_bg";